import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Scrollbars } from 'react-custom-scrollbars';
import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
import {filterByAction} from '../../../actions/commonActions';

import {LBL_FILTER_BY, LBL_RESET, LBL_APPLY} from '../../../configs/labelConfigs'; 
import {LOGIN_SUPER_ADMIN_GROUP} from '../../../configs/staticConfigs';


class FilterByComponent extends Component {

    state = {      
        isFilterOn: false,
    }

    onHideFilterBy = () => {  
        this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn }));  
        this.props.filterByAction(!this.props.isFilterOn); 
    }

    renderThumb({ style, ...props }) {
        const thumbStyle = {
            backgroundColor: `#083461`,
            padding: 0,
            width:"4px",
            borderRadius:"3px"
        };
        return (
            <div
                style={{ ...style, ...thumbStyle }}
                {...props}/>
        );
    }

    applyFilters = (e) => { 
        this.props.onApplyFilterButton(); 
        this.onHideFilterBy();
    }


    render(){

        let userGroupData = userGroupUrlCheck(window.location);
        let userGroup = '';
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }
        let resetClass = ''; 
        if(userGroup===LOGIN_SUPER_ADMIN_GROUP){
            resetClass = ' super-text-reset ';   
        }
        let classNames = "filter-menu padding-filter-left-20" 
        if(this.props.isDetail){

            //classNames =classNames + " over-flow-auto"
        }
        return(

            <div className={classNames} id="filterByMenu">
                {
                    (this.props.isDetail===undefined) &&
                    <div className="filter-tab">
                        {!this.props.hideSliderHeaderFilterBy && <div className="row filter-head">
                            <div className="col-md-12">
                            <h5>{LBL_FILTER_BY} <button onClick={this.onHideFilterBy} className="close-filter text-muted"> <span aria-hidden="true">×</span></button></h5>
                            </div>
                        </div>} 
                        <div className="filter-categories">
                            {this.props.children}                        
                        </div>
                        {!this.props.hideResetApplyButtons && <div className="filter-buttons">
                            <div className="form-group">
                                <div className="row">
                                <div className="col-12">
                                    <a className="btn reset-btn"  onClick={e => this.props.onResetFiltersButton(e)} ><span className={resetClass}>{LBL_RESET}</span></a>
                                    <button className="btn btn-primary"  onClick={e => this.applyFilters(e)}>{LBL_APPLY}</button>
                                </div></div>
                            </div>
                        </div>}
                    </div> 
                }

                {
                    (this.props.isDetail) &&
                        <React.Fragment>
                            <div className="filter-tab" id="filterTab">
                                <div className="row filter-head">
                                    <div className="col-md-12">
                                    <h5>{LBL_FILTER_BY} <button onClick={this.onHideFilterBy} className="close-filter text-muted"> <span aria-hidden="true">×</span></button></h5>
                                    </div>
                                </div> 

                                <Scrollbars 
                                style={{ "height": "80vh"}}
                                autoHide
                                renderTrackHorizontal={props => <div {...props} style={{display: 'none'}} className="track-horizontal"/>}
                                renderView={props => (
                                    <div {...props} style={{ ...props.style, overflowX: 'hidden' }} />
                                )}
                                >
                                <div className="filter-categories marginRight5">
                                    {this.props.children[0]}                        
                                </div>
                                </Scrollbars>

                                <div className="filter-buttons">
                                    <div className="form-group">
                                        <div className="row">
                                        <div className="col-12"> 
                                            <a className="btn reset-btn" onClick={e => this.props.onResetFiltersButton(e)}><span className={resetClass}>{LBL_RESET}</span></a>
                                            <button className="btn btn-primary"  onClick={e => this.applyFilters(e)}>{LBL_APPLY}</button>
                                        </div></div>
                                    </div>
                                </div>
                            </div>
                            <div className="detail-tab" id="detailTab">
                                {this.props.children[1]}  
                            </div>
                            {this.props.children[2] && 
                            <div className="detail-tab hideIt" id="detailTabTwo">
                                {this.props.children[2]}  
                            </div>}
                        </React.Fragment> 
                }
                

            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        isFilterOn: state.commons.isFilterOn,
    }
 };
 
 const mapDispatchToProps = (dispatch) => {
     return bindActionCreators({
          filterByAction:filterByAction  
     },dispatch);
 }
 export default connect(mapStateToProps,mapDispatchToProps)(FilterByComponent);